import { initializeApp } from 'firebase/app';
import { getFirestore, collection, doc, setDoc, getDoc, query, deleteDoc, getDocs } from "firebase/firestore";
import { getStorage, ref, uploadBytes, uploadBytesResumable, getDownloadURL, } from "firebase/storage";

/*
 * --------------
 * Firebase Setup
 * --------------
 */
// TODO: Replace the following with your app's Firebase project configuration
// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCu80kpTPj8VwQff3WHM1GsBevW-fDpBKo",
    authDomain: "cb-prototype-4e3e7.firebaseapp.com",
    projectId: "cb-prototype-4e3e7",
    storageBucket: "cb-prototype-4e3e7.appspot.com",
    messagingSenderId: "251480700217",
    appId: "1:251480700217:web:04dec91c325426375f64e8"
};

const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

// Local data store
var assetDataStore = {}

// Local data store
var assetLibraryDataStore = {}


// Create a root reference
const storage = getStorage();

/**
 * --------------
 * Catalog Asset Updating 
 * --------------
 */
const updateAsset = (asset, insitutionId) => {
    const docRef = doc(db, "branding-assets", insitutionId);

    let data = {}
    data[asset.id] = asset
    setDoc(docRef, data, { merge: true });

    assetDataStore[asset.id] = asset
    return assetDataStore
}

const deleteAsset = (asset, insitutionId) => {
    const docRef = doc(db, "branding-assets", insitutionId);

    delete assetDataStore[asset.id]
    setDoc(docRef, assetDataStore, { merge: false });

    return assetDataStore
}

async function loader({ params }) {
    const institutionid = params.institutionid;

    const docRef = doc(db, "branding-assets", institutionid);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        let data = docSnap.data()
        assetDataStore = data
        return data
    } else {
        console.log("No such document!");
        return {}
    }
}

/**
 * --------------
 * Asset Library Updating 
 * --------------
 */
const updateLibraryAsset = (asset) => {
    const docRef = doc(db, "assets", 'test');

    let data = {}
    data[asset.id] = asset
    setDoc(docRef, data, { merge: true });

    assetLibraryDataStore[asset.id] = asset
    return assetLibraryDataStore
}

const deleteLibraryAsset = (asset) => {
    const docRef = doc(db, "assets", 'test');

    delete assetLibraryDataStore[asset.id]
    setDoc(docRef, assetLibraryDataStore, { merge: false });

    return assetLibraryDataStore
}

const loadLibraryAssets = async () => {
    const docRef = doc(db, "assets", 'test');
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        let data = docSnap.data()
        
        assetLibraryDataStore = data
        return data
    } else {
        console.log("No such document!");
        return {}
    }
}

async function indexLoader() {
    const querySnapshot = await getDocs(collection(db, "branding-assets"));

    var d = []
    querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        let data = doc.data()
        d.push({
            id: doc.id,
            ...data 
        })
    });
    return d
}


/**
 * Asset Uploader Helper
 */
const fileUploader = ({institutionId, file, asset, progressCallback, completeCallback, errorCallback, setAssets}) => {

    // Create a reference to 'mountains.jpg'
    const fileRef = ref(storage, 'branding-assets/' + institutionId + '-' + file.name);
    const uploadTask = uploadBytesResumable(fileRef, file);

    // Register three observers:
    // 1. 'state_changed' observer, called any time the state changes
    // 2. Error observer, called on failure
    // 3. Completion observer, called on successful completion
    uploadTask.on('state_changed',
        (snapshot) => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes);

            // Update download UI
            progressCallback(progress);

            switch (snapshot.state) {
                case 'paused':
                    console.log('Upload is paused');
                    break;
                case 'running':
                    console.log('Upload is running');
                    break;
            }
        },
        (error) => {
            errorCallback("There was an error uploading");
        },
        () => {
            // Handle successful uploads on complete
            // For instance, get the download URL: https://firebasestorage.googleapis.com/...
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                
                // Update asset property src with new download URL 
                const newAsset = {
                    ...asset,
                    src: downloadURL
                }
                
                // Update assets with provided callback
                setAssets({...updateLibraryAsset(newAsset)});

                // Update UI progress to be completed
                completeCallback(newAsset);
            });
        }
    );

    return uploadTask
}


export { loader, indexLoader, fileUploader, updateAsset, deleteAsset, loadLibraryAssets, updateLibraryAsset, deleteLibraryAsset }